<template>
    <div class="p-0">
        <!-- <div v-if="isQrFeatureVisible"> -->
            <div class="font-color-171717">
                <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
                    <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                        <CRow class="m-2">
                            <CCol sm="12">
                                <h3 class="custom-40px-500 text-center mt-3">Manage Feature Access</h3>
                            </CCol>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="10">
                                        <CInput type="text" placeholder="Search..." v-model="searchQuery" />
                                    </CCol>
                                    <CCol sm="2" style="margin-top:-30px;">
                                        <label for="itemsPerPage" class="p-0">Items per page:</label>
                                        <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                            <option value="10">Show 10</option>
                            <option value="20">Show 20</option>
                            <option value="50">Show 50</option>
                            </select>
                                    </CCol>
        
                                </CRow> 
                                <template v-if="Busy == true">
                                    <div class="container text-center">
                                    <pulse-loader
                                        :loading="loading"
                                        :color="color"
                                        :size="size"
                                    ></pulse-loader>
                                    </div>
                                    </template>

                                    <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredList" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">

                                    <template #Name="{ item }">
                                        <td>
                                          <img :src="item.filePath" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
                                            {{ item.name }}
                                        </td>
                                    </template>

                                    <template #Email="{ item }">
                                        <td>
                                            {{ item.email }}
                                        </td>
                                    </template>

                                  
                                    <template #Country="{ item }">
                                        <td>
                                            {{ item.country }}
                                        </td>
                                    </template>

                                    <template #Action="{ item }">
                                        <td>
                                           <img src="../assets/img/smallicon/view_purple.png" width="30px"/>
                                            <img src="../assets/img/smallicon/delete_square.png" @click="OpenDelete(item.Id, item.job)" style="max-width:30px" class="ml-2"> 
                                        </td>
                                    </template>

                                    </CDataTable>

                            
                            </CCol>
        
                        </CRow>
                    </CCard>
                    <br /><br /><br />
                </div>
              
            </div>
      </div>
</template>


<script>
import Vue from "vue";
import QRCode from 'qrcode-generator';
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");
import _ from "lodash";
import { CChartRadar } from '@coreui/vue-chartjs'

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader,
        CChartDoughnut,
        CCol,
        CChartRadar
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            ispopupVisible2: false,
            ispopupVisible3: false,
            access: [],
            user: {},
            currentPage: 1,
            itemsPerPage: 10,
            searchQuery: "",
            fields: [{
                    key: 'Name'
                },
                {
                    key: 'Email'
                }, 
                {
                    key: 'Country'
                },
                {
                    key: 'Action'
                },
            ],
           
            features:[],
            isPopupError: true,
            Busy:false

        };
    },
    created() {},
    computed: {
        filteredList() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            const filtered = this.access
                

            return filtered;
        },
        isQrFeatureVisible() {
            // Check if the user has access to the Blog feature in the "Page" group
            return Array.isArray(this.features) && this.features.filter(f => f.FeaturesGroup === "Page" && f.FeaturesType === "QR" && f.IsVisible).length > 0;
        }

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first
                await this.GetListUser();
                this.getFeatures();

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListUser() {
            this.Busy = true;
            try {
                const response = await this.$API.get(
                    `${this.$GetListUserAccess}`
                );
                if (response.status === 200) {
                    this.Busy = false;
                    this.access = response.data;
                } else {

                }
            } catch (error) {}

        },


        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
      
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },



    }

};
</script>
